import axios from "axios";
import { useState } from "react";

const useUploadImage = () => {
	const [isUploading, setIsUploading] = useState(false);

	const uploadImage = async (file) => {
		if (!file) throw new Error("No file provided");

		try {
			setIsUploading(true);
			const formData = new FormData();
			formData.append("image", file);

			const response = await axios.post(process.env.NEXT_PUBLIC_API_BASE_URL + "images", formData, {
				headers: { "Content-Type": "multipart/form-data" },
			});

			if (response?.data?.signedUrl) {
				return response.data.signedUrl;
			} else {
				throw new Error("Invalid response from server");
			}
		} catch (err) {
			throw new Error("Failed to upload image. Please try again.");
		} finally {
			setIsUploading(false);
		}
	};

	return { uploadImage, isUploading };
};

export default useUploadImage;
